import { Form, OverlayTrigger, Popover, Alert } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
const FormInputControlled = ({
  name,
  loading = false,
  placeholder = null,
  label = null,
  popoverText = null,
  apiErrors = null,
  displayAs = Form.Control,
  className = "",
  customError = null,
  onChangeMiddleware = undefined,
  ...props
}) => {
  const {
    // eslint-disable-next-line no-unused-vars
    formState: { errors, isValid, isDirty, dirtyFields },
    control,
    getFieldState,
  } = useFormContext();

  const fieldState = getFieldState(name);
  return (
    <Form.Group className={className + " mb-3"}>
      {label && <Form.Label>{label}</Form.Label>}

      <Controller
        render={({ field: { onChange, onBlur, value, ref } }) =>
          popoverText ? (
            <OverlayTrigger
              overlay={
                <Popover id="popover-basic">
                  <Popover.Body>{popoverText}</Popover.Body>
                </Popover>
              }
              placement="top"
            >
              <Form.Control
                as={displayAs}
                onBlur={onBlur}
                onChange={(event) => {
                  onChangeMiddleware
                    ? onChange(onChangeMiddleware(event))
                    : onChange(event);
                }}
                value={value}
                ref={ref}
                placeholder={placeholder}
                disabled={loading}
                isValid={fieldState.isDirty && !fieldState.invalid}
                isInvalid={fieldState.invalid}
                {...props}
              />
            </OverlayTrigger>
          ) : (
            <Form.Control
              as={displayAs}
              onBlur={onBlur}
              onChange={(input) => {
                onChangeMiddleware
                  ? onChange(onChangeMiddleware(input))
                  : onChange(input);
              }}
              value={value}
              ref={ref}
              placeholder={placeholder}
              disabled={loading}
              isValid={fieldState.isDirty && !fieldState.invalid}
              isInvalid={fieldState.invalid}
              {...props}
            />
          )
        }
        control={control}
        name={name}
      />
      {customError ? (
        <Form.Control.Feedback type="invalid">
          {customError}
        </Form.Control.Feedback>
      ) : (
        errors[name] && (
          <Form.Control.Feedback type="invalid">
            {errors[name].message}
          </Form.Control.Feedback>
        )
      )}
      {apiErrors && (
        <Alert className="my-2" variant="danger">
          {apiErrors}
        </Alert>
      )}
    </Form.Group>
  );
};

export default FormInputControlled;
